




























import { Observer } from 'mobx-vue'
import { Component, Vue, Provide, Ref, Inject } from 'vue-property-decorator'
import { FarmingViewModel } from '../viewmodels/farming-viewmodel'

@Observer
@Component({
  components: {}
})
export default class SelectLockPeriod extends Vue {
  @Inject() vm!: FarmingViewModel
}
